"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const auth0_react_1 = require("@auth0/auth0-react");
const apiUtils_1 = require("../util/apiUtils");
const auth_1 = require("../util/auth");
const fetchBlob = async (fetchUrl, signal, getAuthHeader, getAccessTokenSilently, loginWithRedirect, body) => {
    const accessToken = await (0, auth_1.getAccessToken)(getAccessTokenSilently);
    const headers = {
        "Content-Type": "application/json",
        ...getAuthHeader(accessToken),
    };
    const response = await fetch((0, apiUtils_1.getAPIUrl)() + fetchUrl, {
        signal,
        method: body ? "POST" : "GET",
        body,
        headers,
    });
    if (!response.ok) {
        let message = `HTTP ${response.status}`;
        let serverJson;
        try {
            if (response.headers.get("content-type")?.includes("application/json")) {
                serverJson = await response.json();
                message = serverJson?.error || serverJson?.message || message;
            }
            else {
                message = (await response.text()).slice(0, 1000) || message;
            }
        }
        catch {
            /* ignore parse errors */
        }
        const err = new Error(message);
        err.status = response.status;
        if (serverJson) {
            err.error = serverJson.error || serverJson.code;
            err.details = serverJson;
        }
        if ((0, auth_1.shouldTriggerLoginRedirect)(err, response.status)) {
            loginWithRedirect();
        }
        throw err;
    }
    const filename = parseFilename(response.headers.get("content-disposition"));
    triggerDownload(await response.blob(), filename ?? "download");
};
const parseFilename = (contentDisposition) => {
    if (!contentDisposition)
        return;
    const star = /filename\*\s*=\s*[^']*''([^;]+)/i.exec(contentDisposition);
    const normal = /filename\s*=\s*"?([^";]+)"?/i.exec(contentDisposition);
    let filename = star ? decodeURIComponent(star[1]) : normal?.[1];
    return filename?.replace(/[\\/]+/g, "_");
};
const triggerDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
const useFetchBlob = (initialUrl, initialBody, waitForBody) => {
    const { getAuthHeader, getAccessTokenSilently } = (0, auth_1.useAuthentication)();
    const { loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    const [url, setUrl] = (0, react_1.useState)(initialUrl);
    const [postBody, setPostBody] = (0, react_1.useState)(initialBody);
    const [state, setState] = (0, react_1.useState)({
        status: apiUtils_1.LoaderStatus.Idle,
    });
    const runFetch = () => {
        if (!url || (waitForBody && !postBody))
            return;
        const abortController = new AbortController();
        setState({ status: apiUtils_1.LoaderStatus.Loading });
        fetchBlob(url, abortController.signal, getAuthHeader, getAccessTokenSilently, loginWithRedirect, postBody)
            .then(() => setState({ status: apiUtils_1.LoaderStatus.Success }))
            .catch((error) => setState({ status: apiUtils_1.LoaderStatus.Error, error }));
    };
    (0, react_1.useEffect)(runFetch, [url, postBody]);
    return [state, setUrl, setPostBody, runFetch];
};
exports.default = useFetchBlob;
